import React from 'react';
import { SkeletonLoader } from '../../../components/loading/SkeletonLoader';
import { Grid, Button } from '@material-ui/core';
import { GenerateCustomFieldFile } from '../../common/GenerateCustomFieldFile';
import { FormSectionAccordionCard } from '../../../components/cards/FormSectionAccordionCard';
import { FieldType } from '../../../enquiryCustomFields/selectors/CustomFieldTypeSelector';
import { getField } from '../../../enquiryCustomFields/common/getField';
import { CustomFieldByHierarchy } from '../../../enquiryCustomFields/CustomFieldRepositores';
import { EnquiryDetail } from '../../models/Enquiry';
import PrintIcon from '@material-ui/icons/Print';
import AssignmentIcon from '@material-ui/icons/Assignment';
import type { EnquiryFormClasses } from '../EnquiryFormDrawer';

// Explicit request (EnquiryFormDrawer split): the "Further Details" (custom fields) groups, moved out of the
// drawer's getCustomFields with their JSX unchanged. Memoised on exactly what it displays, so typing in
// another part of the form (Contact Details, for instance) no longer re-renders every custom field.
interface CustomFieldsSectionProps {
    isLoading: boolean;
    customFieldGroups: CustomFieldByHierarchy[] | undefined;
    isExistingEnquiry: boolean;
    enquiryDetail: EnquiryDetail;
    currency: string;
    classes: EnquiryFormClasses;
}

export const CustomFieldsSection: React.FC<CustomFieldsSectionProps> = React.memo(({
    isLoading, customFieldGroups, isExistingEnquiry, enquiryDetail, currency, classes,
}) => {
    if (isLoading) {
        return <SkeletonLoader variant="form" rows={4} columns={2} />;
    }

    if (customFieldGroups && customFieldGroups.length > 0) {

        return (
            <Grid container={true} spacing={1}>
                {isExistingEnquiry ? (
                    <Grid item={true} xs={12} sm={12} md={12} lg={12}>
                        <Button
                            onClick={() => GenerateCustomFieldFile({
                                fields: customFieldGroups,
                                values: enquiryDetail.customFields,
                                enquiryDetail: enquiryDetail,
                                currency: currency,
                                directDownload: false
                            })}
                            startIcon={<PrintIcon />}
                            color="primary"
                        >
                            Print
                        </Button>
                    </Grid>
                ) : null}
                {customFieldGroups.map((group, index) =>(
                    <Grid item={true} xs={12} sm={12} md={12} lg={12} key={index}>
                        <FormSectionAccordionCard
                            title={group.customFieldGroupName}
                            description={group.customFieldGroupDescription || undefined}
                            bgColor={'#e3f2fd'}
                            color={'#1565c0'}
                            icon={AssignmentIcon}
                        >

                            <Grid container={true} spacing={2}>
                                {group.customField.filter((field) => field.isActive).map((field, index) => {

                                    if (field.customFieldType === FieldType['Multi Line'] || field.customFieldType === FieldType['Label'] || field.customFieldType === FieldType['Yes/No']) {
                                        return (
                                            <Grid item={true} xs={12} sm={12} md={12} lg={12} key={index} className={classes.fieldRowGap}>
                                                {getField(field, index, group.customFieldGroupGuid, { variant: 'outlined', size: 'small' })}
                                            </Grid>
                                        )
                                    } else {
                                        return (
                                            <Grid item={true} xs={12} sm={12} md={6} lg={6} key={index} className={classes.fieldRowGap}>
                                                {getField(field, index, group.customFieldGroupGuid, { variant: 'outlined', size: 'small' })}
                                            </Grid>
                                        )
                                    }

                                })}
                            </Grid>
                        </FormSectionAccordionCard>

                    </Grid>
                ))}
            </Grid>
        );
    }

    return null;
});
CustomFieldsSection.displayName = 'CustomFieldsSection';
